import RouterView from "@/components/ui/RouterView.vue"

// function getRoutes()

const drawerItems = [
  {
    title: "Druh publika",
    route: "/audiences/new/audience/type",
    submenu: [],
  },
  {
    title: "Základní údaje",
    route: "/audiences/new/audience/targeting-basics",
    submenu: [],
  },
  {
    title: "Detailní zacílení",
    route: "/audiences/new/audience/targeting-interests",
    submenu: [],
  },
  {
    title: "Vyloučené zacílení",
    route: "/audiences/new/audience/targeting-excluded-interests",
    submenu: [],
  },
  {
    title: "Shrnutí publika",
    route: "/audiences/new/audience/targeting-summary",
    submenu: [],
  },
]

export default [
  {
    path: "",
    component: () => import("@/views/audiences/AudiencesIndex.vue"),
  },
  {
    path: "new",
    component: RouterView,
    children: [
      {
        path: "",
        redirect: "audience",
      },
      {
        path: "audience",
        component: RouterView,
        children: [
          {
            path: "",
            redirect: "type",
          },
          {
            path: "type",
            component: () => import("@/views/audiences/edit/AudienceType.vue"),
            meta: {
              title: "Jaké publikum chcete vytvořit?",
              nestedMode: true,
              drawerItems,
            },
            props: {
              prevRoute: null,
              nextRoute: "/audiences/new/audience/targeting-basics",
              storeNamespace: "audiences",
            },
          },
          {
            path: "targeting-basics",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingBasics.vue"),
            meta: {
              title: "Cílení - Základní údaje",
              nestedMode: true,
              drawerItems,
            },
            props: {
              prevRoute: "/audiences/new/audience/type",
              nextRoute: "/audiences/new/audience/targeting-interests",
              targetingSummaryRoute:
                "/audiences/new/audience/targeting-summary",
              storeNamespace: "audiences",
            },
          },
          {
            path: "targeting-interests",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingInterests.vue"),
            meta: {
              title: "Cílení - Zájmy a demografie",
              nestedMode: true,
              drawerItems,
            },
            props: {
              prevRoute: "/audiences/new/audience/targeting-basics",
              nextRoute: "/audiences/new/audience/targeting-excluded-interests",
              storeNamespace: "audiences",
            },
          },
          {
            path: "targeting-excluded-interests",
            component: () =>
              import(
                "@/views/audiences/edit/targeting/TargetingExcludedInterests.vue"
              ),
            meta: {
              title: "Cílení - Vyloučené zájmy a demografie",
              nestedMode: true,
              drawerItems,
            },
            props: {
              prevRoute: "/audiences/new/audience/targeting-interests",
              nextRoute: "/audiences/new/audience/targeting-summary",
              storeNamespace: "audiences",
            },
          },
          {
            path: "targeting-summary",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingSummary.vue"),
            meta: {
              title: "Cílení - Shrnutí",
              nestedMode: true,
              drawerItems,
            },
            props: {
              prevRoute: "/audiences/new/audience/targeting-excluded-interests",
              nextRoute: null,
              targetingBasicsRoute: "/audiences/new/audience/targeting-basics",
              targetingInterestsRoute:
                "/audiences/new/audience/targeting-interests",
              targetingExcludedInterestsRoute:
                "/audiences/new/audience/targeting-excluded-interests",
              storeNamespace: "audiences",
            },
          },
        ],
      },
    ],
  },
]
